import React from "react";
import { FaInstagram, FaFacebookF, FaYoutube } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-home">
      <div className="footer-content-home">
        <div className="footer-left-home">
          <h2 className="footer-title-home">Development Education & Welfare Trust</h2>
          <p className="footer-tagline-home">Empowering Communities, Transforming Lives</p>
          <div className="footer-social-home">
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="footer-social-icon-home" />
            </a>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebookF className="footer-social-icon-home" />
            </a>
            <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">
              <FaYoutube className="footer-social-icon-home" />
            </a>
          </div>
        </div>

        <div className="footer-right-home">
          <p><strong>Email:</strong> lukasdewt@yahoo.com</p>
          <p><strong>Phone:</strong> +91 9932144384</p>
          <p><strong>Address:</strong> Chinchua Tea Estate, Chinchula Road, Kalchini, 735217, West Bengal, India</p>
        </div>
      </div>

      <div className="footer-bottom-home">
        <p>
          © 2024 Development Education & Welfare Trust. All Rights Reserved |{" "}
          <a href="https://tirkey.in" target="_blank" rel="noopener noreferrer">
            tirkey.in
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
